var _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSendMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "25px",
  height: "25px",
  viewBox: "0 0 32 32"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "send")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.667 26.307v-7.983l17.143-2.304-17.143-2.304v-7.983l24 10.285z",
  fill: "#c8b5df"
})));
export { SvgSendMessage as ReactComponent };
export default __webpack_public_path__ + "assets/icons/send_message.f9e8f0.svg";